import { render, staticRenderFns } from "./GlArea.vue?vue&type=template&id=231480da&"
import script from "./GlArea.vue?vue&type=script&lang=js&"
export * from "./GlArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports